"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VERIFYING_ORDER_TEXT = exports.RESET_TO_AGENT_VERSION_LABEL = exports.ProposalCardActions = exports.EDIT_BUTTON_LABEL = exports.DETAILS_BUTTON_LABEL = void 0;
var _react = _interopRequireDefault(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _RemedyActionPrimitives = require("@common/components/remedy/RemedyActionPrimitives");
var _WrittenBackIndicator = require("./WrittenBackIndicator");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var EDIT_BUTTON_LABEL = exports.EDIT_BUTTON_LABEL = "Edit this redline";
var RESET_TO_AGENT_VERSION_LABEL = exports.RESET_TO_AGENT_VERSION_LABEL = "Reset to the agent's version";
var VERIFYING_ORDER_TEXT = exports.VERIFYING_ORDER_TEXT = "Verifying order";
var DETAILS_BUTTON_LABEL = exports.DETAILS_BUTTON_LABEL = "Details";
var VerifyingOrderIndicator = function VerifyingOrderIndicator() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    role: "status",
    className: "flex flex-shrink-0 items-center gap-1 whitespace-nowrap text-[11px] font-medium text-[#686766]",
    "data-sentry-component": "VerifyingOrderIndicator",
    "data-sentry-source-file": "ProposalCardActions.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "aria-hidden": "true",
      className: "h-3 w-3 flex-shrink-0 rounded-full border-2 border-primary border-t-transparent animate-spin"
    }), VERIFYING_ORDER_TEXT]
  });
};
var ProposalCardActions = exports.ProposalCardActions = function ProposalCardActions(_ref) {
  var _edit$isEditing;
  var onApply = _ref.onApply,
    isApplying = _ref.isApplying,
    applyHeldBackReason = _ref.applyHeldBackReason,
    onGoToIssue = _ref.onGoToIssue,
    isActionApplied = _ref.isActionApplied,
    isActionDismissed = _ref.isActionDismissed,
    isDismissalSaving = _ref.isDismissalSaving,
    _ref$isPartiallyAppli = _ref.isPartiallyApplied,
    isPartiallyApplied = _ref$isPartiallyAppli === void 0 ? false : _ref$isPartiallyAppli,
    _ref$isWrittenBack = _ref.isWrittenBack,
    isWrittenBack = _ref$isWrittenBack === void 0 ? false : _ref$isWrittenBack,
    onActionDismissed = _ref.onActionDismissed,
    onActionUndismissed = _ref.onActionUndismissed,
    applyFailure = _ref.applyFailure,
    conflictingCards = _ref.conflictingCards,
    _ref$edit = _ref.edit,
    edit = _ref$edit === void 0 ? null : _ref$edit,
    appliedIndicator = _ref.appliedIndicator,
    leadingContent = _ref.leadingContent,
    pendingIndicator = _ref.pendingIndicator,
    _ref$isVerifyingOrder = _ref.isVerifyingOrder,
    isVerifyingOrder = _ref$isVerifyingOrder === void 0 ? false : _ref$isVerifyingOrder;
  var canAct = !isActionDismissed && !isPartiallyApplied;
  var editorIsOpen = (_edit$isEditing = edit === null || edit === void 0 ? void 0 : edit.isEditing) !== null && _edit$isEditing !== void 0 ? _edit$isEditing : false;
  function renderEditControl() {
    if (edit !== null && edit.isEditing) return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      ref: edit.editorActionsSlotRef,
      className: "flex flex-shrink-0 items-center gap-2"
    });
    if (!canAct || isActionApplied || edit === null) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      "aria-label": EDIT_BUTTON_LABEL,
      title: EDIT_BUTTON_LABEL,
      onClick: function onClick(event) {
        event.stopPropagation();
        edit.onEdit();
      },
      className: "flex flex-shrink-0 cursor-pointer items-center border-none bg-transparent p-0.5",
      "data-sentry-component": "renderEditControl",
      "data-sentry-source-file": "ProposalCardActions.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.EditIcon, {
        width: 14,
        height: 14,
        className: "text-[#686766]",
        "data-sentry-element": "EditIcon",
        "data-sentry-source-file": "ProposalCardActions.tsx"
      })
    });
  }
  function renderResetToAgentVersionButton() {
    var _edit$onResetToAgentV;
    var onReset = (_edit$onResetToAgentV = edit === null || edit === void 0 ? void 0 : edit.onResetToAgentVersion) !== null && _edit$onResetToAgentV !== void 0 ? _edit$onResetToAgentV : null;
    if (!canAct || isActionApplied || edit === null || edit.isEditing || onReset === null) return null;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
      type: "button",
      "aria-label": RESET_TO_AGENT_VERSION_LABEL,
      title: RESET_TO_AGENT_VERSION_LABEL,
      onClick: function onClick(event) {
        event.stopPropagation();
        onReset();
      },
      className: "flex flex-shrink-0 cursor-pointer items-center border-none bg-transparent p-0.5",
      "data-sentry-component": "renderResetToAgentVersionButton",
      "data-sentry-source-file": "ProposalCardActions.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.UndoIcon, {
        width: 14,
        height: 14,
        className: "text-[#686766]",
        "data-sentry-element": "UndoIcon",
        "data-sentry-source-file": "ProposalCardActions.tsx"
      })
    });
  }
  function renderStatus() {
    if (isActionDismissed) {
      return onActionUndismissed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissedIndicator, {
        onClick: function onClick(event) {
          event.stopPropagation();
          onActionUndismissed();
        },
        isSaving: isDismissalSaving
      }) : null;
    }
    if (applyFailure && isWrittenBack) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_WrittenBackIndicator.WrittenBackIndicator, {
      writtenBackReason: applyFailure
    });
    if (applyFailure) return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyFailedIndicator, {
      reason: applyFailure,
      conflictingCards: conflictingCards,
      partlyApplied: isPartiallyApplied
    });
    if (isActionApplied) return appliedIndicator !== null && appliedIndicator !== void 0 ? appliedIndicator : /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyAppliedIndicator, {});
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [pendingIndicator !== null && pendingIndicator !== void 0 ? pendingIndicator : null, isVerifyingOrder ? /*#__PURE__*/(0, _jsxRuntime.jsx)(VerifyingOrderIndicator, {}) : null]
    });
  }
  var applyButton = canAct ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyApplyButton, {
    onClick: function onClick(event) {
      event.stopPropagation();
      void onApply();
    },
    isLoading: isApplying,
    disabled: applyHeldBackReason !== null,
    title: applyHeldBackReason !== null && applyHeldBackReason !== void 0 ? applyHeldBackReason : undefined
  }) : null;
  var goToButton = !isActionDismissed && onGoToIssue ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyGoToIssueButton, {
    onClick: function onClick(event) {
      event.stopPropagation();
      void onGoToIssue();
    },
    children: "Go to issue"
  }) : null;
  var dismissButton = !editorIsOpen && !isActionApplied && !isActionDismissed && onActionDismissed ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_RemedyActionPrimitives.RemedyDismissButton, {
    onClick: function onClick(event) {
      event.stopPropagation();
      onActionDismissed();
    },
    isSaving: isDismissalSaving
  }) : null;
  // const detailsButton = onShowDetails
  //   ? (
  //     <button
  //       type="button"
  //       aria-label={DETAILS_BUTTON_LABEL}
  //       title={DETAILS_BUTTON_LABEL}
  //       onClick={(event) => {
  //         event.stopPropagation();
  //         onShowDetails();
  //       }}
  //       className="flex flex-shrink-0 cursor-pointer items-center gap-1 border-none bg-transparent p-0.5 text-[11px] text-[#686766]"
  //     >
  //       <Info size={14} aria-hidden="true" />
  //       {DETAILS_BUTTON_LABEL}
  //     </button>
  //   )
  //   : null;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex items-center gap-2 mb-1 min-h-[24px]",
    "data-sentry-component": "ProposalCardActions",
    "data-sentry-source-file": "ProposalCardActions.tsx",
    children: [leadingContent, applyButton, goToButton, renderEditControl(), renderResetToAgentVersionButton(), dismissButton, renderStatus()]
  });
};